import { render, staticRenderFns } from "./ListHeaderSetting.vue?vue&type=template&id=063906c0"
import script from "./ListHeaderSetting.vue?vue&type=script&lang=js"
export * from "./ListHeaderSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports